import { computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useAffiliateStore from '../store'
import { useAffiliateStatus } from '../requests/query'
import featureFlag from '@/config/featureFlag'
import useAuthStore from '@/modules/Auth/store'
import useCurrencyStore from '@/modules/Core/store/currency'
import useToastStore from '@/modules/Core/store/toast'

export function useAffiliate() {
  const currencyStore = useCurrencyStore()
  const authStore = useAuthStore()
  const affiliateStore = useAffiliateStore()
  const toastStore = useToastStore()

  const { t } = useI18n()

  const currency = computed(() => currencyStore.currency.title)
  const enabled = computed(
    () => featureFlag.affiliateProgram && authStore.loggedIn
  )
  const { data, isLoading, isFetching, refetch } = useAffiliateStatus(
    currency,
    {
      enabled,
      onError(error: unknown) {
        const axiosError = error as AxiosCustomError

        const isAffiliateNotExist =
          axiosError?.response?.data.errors &&
          axiosError?.response.data.errors.length &&
          axiosError?.response.data.errors[0].errorCode === '404'

        if (isAffiliateNotExist && affiliateStore.pendingAffiliateModal)
          affiliateStore.openAffiliateModal()
      },
    }
  )

  watch(
    () => data?.value,
    (newData) => {
      if (newData) {
        affiliateStore.setAffiliateDetails(newData)

        if (newData && affiliateStore.pendingAffiliateModal) {
          toastStore.addToast({
            color: 'success',
            title: t('affiliate.affiliateExitMessage'),
          })
        } else {
          affiliateStore.openAffiliateModal()
        }
      }
    }
  )

  watch(
    () => isLoading.value,
    (value) => {
      affiliateStore.setIsLoading(value)
    },
    {
      immediate: true,
    }
  )

  const showAffiliateButton = computed(
    () => !authStore.loggedIn || !affiliateStore.affiliateDetails
  )

  return {
    data,
    isLoading,
    isFetching,
    showAffiliateButton,
    refetch,
  }
}
